import { render } from "./SidebarComponent.vue?vue&type=template&id=46954c60&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=46954c60&scoped=true&lang=css"
import "../assets/css/staff-sidebar-compact.css?vue&type=style&index=1&id=46954c60&scoped=true&lang=css&external"
import "../assets/css/staff-sidebar-layout.css?vue&type=style&index=2&lang=css&external"
import "../assets/css/staff-sidebar-modern.css?vue&type=style&index=3&id=46954c60&scoped=true&lang=css&external"
import "../assets/css/staff-topbar-refined.css?vue&type=style&index=4&id=46954c60&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46954c60"]])

export default __exports__